<template>
  <v-dialog :value="value" width="430" persistent>
    <v-card>
      <v-card-title>
        Confirm Mass Copy
      </v-card-title>
      <v-card-text>
        <v-col cols="auto" class="ma-0 px-0 pb-0 d-inline-flex">
          <v-icon class="mr-4" color="warning">mdi-alert</v-icon>
          Existing features will be moved to Page 7 of their respective ads. Proceed? 
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey darken-1" text :class="body" @click="$emit('cancel')">
          Cancel
        </v-btn>
        <v-btn color="warning" :class="body" @click="confirm">
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
export default {
  name: 'MassCopyConfirm',
  props: {
    value: Boolean,
  },
  mixins: [displayHelpers],
  methods: {
    confirm() {
      this.$emit('confirmAction')
    }
  }
}
</script>